import { render, staticRenderFns } from "./FichaGaleria.vue?vue&type=template&id=aa65a6b2"
import script from "./FichaGaleria.vue?vue&type=script&lang=js"
export * from "./FichaGaleria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports